// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"133c6ddb","257":"38d78058","542":"778b2615","566":"20ff92c4","726":"5b7f8a32","765":"d6e8fcd0","963":"330cfad7"}[chunkId] + ".chunk.js";
};